<template>
  <!-- 内部ユーザー編集 -->
  <div id="UserProfile">
    <div id="container">
      <div class="labelTitle lable">ユーザープロファイル</div>
      <div>
        <div id="item-contens">
          <div class="card-content margin-top">
            <table>
              <tr><th>【ユーザー情報】</th><td></td></tr>
              <tr><th>ID</th><td>{{data.id}}</td></tr>
              <tr><th>権限</th><td>{{data.roleId | roleFilter}}</td></tr>
              <tr><th>ユーザー名<span class="require" /></th><td><input type="text" class="nameInput validate"  v-model="data.lastName" placeholder="姓" name="ユーザー名（姓）" validate="required" maxlength="50"/><input type="text" class="nameInput validate"  v-model="data.firstName" placeholder="名" name="ユーザー名（名）" validate="required" maxlength="50"/></td></tr>
              <tr><th>ユーザー名(カナ)<span class="require" /></th><td><input type="text" class="nameInput validate"  v-model="data.lastNameKana" placeholder="セイ" validate="required|kana" name="ユーザー名（姓カナ）" maxlength="50"/><input type="text" class="nameInput validate"  v-model="data.firstNameKana" placeholder="メイ" validate="required|kana" name="ユーザー名（名カナ）" maxlength="50"/></td></tr>
              <tr><th>メールアドレス<span class="require" /></th><td><input type="text" class="validate" v-model="data.mail" name="メールアドレス" validate="required|mail" maxlength="100"/></td></tr>
              <tr><th>メールアドレス(確認)<span class="require" /></th><td><input type="text" class="validate" v-model="mailconfirm" name="メールアドレス（確認）" validate="required" maxlength="100"/></td></tr>
              <tr>
                <th>連絡先(直通)<span class="require" /></th>
                <td>
                  <input
                    type="text"
                    class="validate"
                    :class="{'border-red': invalidPhoneNumber}"
                    v-model="data.phoneNumber"
                    validate="required|numeric"
                    name="連絡先(直通)"
                    maxlength="11"
                    :placeholder="phonePlaceholder"
                  />
                  <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <tr><th>所属<span class="require" /></th>
                <td>
                  <select v-model="data.salesOfficeCode" class="validate" validate="required" name="所属" >
                    <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                      {{office.name}}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>営業員コード</th>
                <td>
                  <input type="text" v-model="data.salesStaffCode" name="営業員コード" maxlength="10"/>
                </td>
              </tr>
            </table>
            <div class="searchButton-area" style="margin-bottom:10px;">
              <b-button class="is-primary" v-on:click="regist">更新</b-button>
            </div>
          </div>
        </div>
        <div id="item-contens"  v-if="!isChangePassword">
          <div class="card-content margin-top">
            <table>
              <tr><th>【パスワード変更】</th><td></td></tr>
              <tr><th>変更前パスワード</th><td><input type="password" v-model="oldPassword" autocomplete="new-password"/></td></tr>
              <tr><th>変更後パスワード</th><td><input type="password" v-model="newPassword" autocomplete="new-password"/></td></tr>
              <tr><th>変更後パスワード(確認)</th><td><input type="password" v-model="newPasswordComf" autocomplete="new-password"/></td></tr>
              <tr><th></th><td>※パスワードは8桁以上5文字以上の異なる文字で入力してください。</td></tr>
            </table>
            <div class="searchButton-area" style="margin-bottom:10px;">
              <b-button class="is-primary" v-on:click="changePassword">パスワード変更</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  invalidNumberMessage,
  phonePlaceholder,
} from "@/components/mock/base/const.js";

export default {
  name: "UserProfile",
  created() {
    this.isChangePassword = JSON.parse(sessionStorage.getItem('userInfo')).ssologin;
  },
  methods: {
    regist: function() {
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        if(this.data.mail != this.mailconfirm){
          this.showErrorMessage("メールアドレス(確認)が一致しません。");
          return;
        }
        // Web Api Call
        var _this = this;
        var body = this.createBody();
        this.apiCall(
          function(client){
            return client.apis.internalMaintenance.setMaintenanceInternalUserUpdatePOST({
              body:body
            });
          },
          async function(result){
            _this.showSuccess(result, function(){
              _this.dataOrg.salesStaffCode = _this.data.salesStaffCode;
              _this.updateUserInfo();
            });
          },
          function(result){
            _this.showErrorMessage(result);
          }
        ); 
      }
    },
    createBody: function(){
      let userInfo = {
        userId: this.data.id,
        kind:this.data.roleId,
        lastName:this.data.lastName,
        firstName:this.data.firstName,
        lastNameKana:this.data.lastNameKana,
        firstNameKana:this.data.firstNameKana,
        mail:this.data.mail,
        phoneNumber:this.data.phoneNumber,
        office: this.data.salesOfficeCode,
        salesStaffCode: this.data.salesStaffCode ? this.data.salesStaffCode : ""
      };
      return userInfo;
    },
    updateUserInfo: function() {
      var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      userInfo.mail = this.data.mail
      userInfo.lastName = this.data.lastName
      userInfo.firstName = this.data.firstName
      userInfo.lastNameKana = this.data.lastNameKana
      userInfo.firstNameKana = this.data.firstNameKana
      userInfo.phoneNumber = this.data.phoneNumber
      userInfo.salesOfficeCode = this.data.salesOfficeCode
      userInfo.salesStaffCode = this.data.salesStaffCode
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
      this.$emit("update-user-info");
    },
    changePassword: function() {
      var _this = this;
      if(this.oldPassword == ""){
        this.showErrorMessage("変更前パスワードを入力してください。");
        return;
      } else if(this.newPassword == "") {
        this.showErrorMessage("変更後パスワードを入力してください。");
        return;
      } else if(this.newPasswordComf == "") {
        this.showErrorMessage("変更後パスワード(確認)を入力してください。");
        return;
      } else if(this.oldPassword == this.newPassword){
        this.showErrorMessage("変更前と違うパスワードを入力してください。");
        return;
      }
      //newパスワードの形式チェック
      if(this.newPassword.length < 8){
        this.showErrorMessage("変更後パスワードは8文字以上で指定してください。");
        return;
      } else if(this.newPassword.length > 256){
        this.showErrorMessage("変更後パスワードは256文字以下で指定してください。");
        return;
      } else {
        var array1 = this.newPassword.split('');
        var array2 = Array.from(new Set(array1));
        if(array2.length < 5){
          this.showErrorMessage("変更後パスワードは5文字以上の異なる文字を使用してください。");
          return;
        }
      }
      //新パスワード一致確認
      if(this.newPassword != this.newPasswordComf){
        this.showErrorMessage("変更後パスワード(確認)が一致しません。");
        return;
      }
      
      this.apiCall(
        function(client){
          return client.apis.auth.passwordChangePOST({
            body: {
                currentpassword: _this.oldPassword,
                newpassword: _this.newPassword
            }
          });
        },
        function(result){
          _this.showSuccess(result, function(){
            _this.oldPassword = "";
            _this.newPassword = "";
            _this.newPasswordComf = "";            
          });
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    var salesOfficeMaster = this.getSalesOfficeMaster();
    return {
      data: userInfo,
      dataOrg: this.getCopy(userInfo),
      mailconfirm:userInfo.mail,
      oldPassword:"",
      newPassword:"",
      newPasswordComf:"",
      salesOfficeMaster: salesOfficeMaster,
    };
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  watch: {
    "data.phoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
  },
};
</script>
<style lang="scss" scoped>
.nameInput {
  width: 463px !important;;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/profile/UserProfile.vue